export default "__VITE_ASSET__DX24OH5D__"